import { render, staticRenderFns } from "./TicketQuestionForm.vue?vue&type=template&id=c45fcd04&scoped=true"
import script from "./TicketQuestionForm.vue?vue&type=script&lang=js"
export * from "./TicketQuestionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45fcd04",
  null
  
)

export default component.exports